import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import imgSrc from '@assets/undraw/undraw_add-notes_9xls.svg'
import { TagFormModal } from './TagFormModal'
import { useState } from 'react'
import { Button } from '@root/components'
import { motion } from 'framer-motion'

const TagSettingsLander = () => {
  const [isTagFormModalOpen, setIsTagFormModalOpen] = useState(false)

  const [t] = useTranslation()

  const onTagFormModalClose = () => {
    setIsTagFormModalOpen(false)
  }

  const onCreateNewTag = () => {
    setIsTagFormModalOpen(true)
  }

  return (
    <>
      <StyledLander>
        <StyledImg src={imgSrc} alt="Tag Settings" />

        <h2>{t('settings.tags.addFirstTitle')}</h2>

        <p>{`${t('settings.tags.info')}`}</p>
        <p>{t('settings.tags.createFirstText')}</p>

        <Button intent="primary" type="button" onClick={() => onCreateNewTag()}>
          {t('settings.tags.addNewTag')}
        </Button>
      </StyledLander>

      <TagFormModal isVisible={isTagFormModalOpen} handleOnClose={onTagFormModalClose} />
    </>
  )
}

export default TagSettingsLander

const StyledLander = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.lg}rem;
  overflow: auto;

  h2 {
    font-size: ${({ theme }) => theme.fontSize.lg}rem;
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.md}rem;
    max-width: 400px;
    color: ${({ theme }) => theme.colors.metalGray};
    margin-bottom: ${({ theme }) => theme.spacing.md}rem;
  }

  button {
    margin-top: 1rem;
  }
`

const StyledImg = styled(motion.img).attrs({
  src: imgSrc,
  initial: { opacity: 0, scale: 0.8, y: 50, rotate: 15 },
  animate: { opacity: 1, scale: 1, y: 0, rotate: 0 },
  transition: { delay: 0.1 }
})`
  max-width: 340px;
  padding: 3rem;
  padding-top: 1rem;
`
